import React from "react";
import { Card, CopyHash, KeyValueList } from "@sscs/ui";
import { humanReadableBytes } from "@sscs/utils";
import { ROOT_FILE_PATH } from "../../../constants";
import { getSha256 } from "../../../utils";
import styles from "./malwareDetails.module.scss";
const FileInformation = ({ info }) => {
    var _a;
    const fileTypeInfo = `${info.type}/${info.subtype}${info.format ? `/${info.format}` : ""}`;
    const sha256 = getSha256(info);
    return (React.createElement(Card.Card, null,
        React.createElement(Card.Title, null, "File information"),
        React.createElement(Card.Content, null, React.createElement(KeyValueList, { list: {
                Type: fileTypeInfo,
                Size: humanReadableBytes(Number(info.size)),
                Hash: (React.createElement("div", { className: styles["file-hash"] },
                    React.createElement("span", null, sha256),
                    React.createElement(CopyHash, { id: `copy-hash`, sha256: sha256 }))),
                Path: (_a = info.path) !== null && _a !== void 0 ? _a : ROOT_FILE_PATH,
            } }))));
};
export default FileInformation;
//# sourceMappingURL=FileInformation.js.map